var exports = {
  "K": "userRestrictedContainer__r5hbel",
  "y": "backToAllIssuesButton__HvFmPh",
};

module.exports = exports;
